export const PDF_VIEWER_SELECTION_AREA_BOX_WIDTH = 165

export const PDF_VIEWER_SELECTION_AREA_BOX_MIN_WIDTH = 25

export const PDF_VIEWER_SELECTION_AREA_BOX_HEIGHT = 85

export const PDF_VIEWER_SELECTION_AREA_BOX_MIN_HEIGHT = 10

// a select area taller than this share of the page is never useful for ocr
export const PDF_VIEWER_SELECTION_AREA_BOX_MAX_HEIGHT_RATIO = 0.2

// the box is placed with css offsets, so its x/y pair maps onto left/top
export const PDF_VIEWER_SELECTION_AREA_BOX_STYLE_PROPERTY_BY_COORDINATE = {
  x: 'left',
  y: 'top',
}
